import { FORMIK_VALIDATION } from 'enums';

function getKnowledgeAreaCopyName(knowledgeAreaName: string): string {
  const ending = ' COPY';
  const overPossibleLen = 46;

  if (knowledgeAreaName.length >= overPossibleLen) {
    const maxLenWithoutEnding =
      knowledgeAreaName.length -
      (knowledgeAreaName.length +
        ending.length -
        FORMIK_VALIDATION.KNOWLEDGE_AREA_NAME_MAX);
    return `${knowledgeAreaName.slice(0, maxLenWithoutEnding)}${ending}`;
  }
  return `${knowledgeAreaName}${ending}`;
}

export { getKnowledgeAreaCopyName };
